import React, { Fragment } from 'react';
import { Badge } from 'Components/frameworks/badge/Badge';
export type HeaderLayerContentProps = {
  title?: string;
  activeCount?: number;
};
export const HeaderLayerContent = ({ activeCount, title }: HeaderLayerContentProps) => (
  <Fragment>
    {!!title && title}
    {activeCount ? (
      <Badge
        className="ms-10 size-32 border-saffron bg-saffron text-14 text-black"
        label={<span className="me-1 mt-1 font-bold text-black">{activeCount}</span>}
        variant="pill"
      />
    ) : null}
  </Fragment>
);
